export default async function getEcoEducation({ context, nextMiddleware }){
    try {
        context.store.dispatch('menuUI/selectTab', 'ecoEducation');
    }
    catch(e){
        console.error(e);
        return context.next(false);
    }
    return nextMiddleware()
}
